var map = {
	"./symbol_0.png": 6303,
	"./symbol_1.png": 26326,
	"./symbol_10.png": 20548,
	"./symbol_11.png": 46701,
	"./symbol_12.png": 56022,
	"./symbol_2.png": 7949,
	"./symbol_3.png": 51652,
	"./symbol_4.png": 33307,
	"./symbol_5.png": 35442,
	"./symbol_6.png": 26153,
	"./symbol_7.png": 71328,
	"./symbol_8.png": 15559,
	"./symbol_9.png": 97246
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68122;